import { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import type { Swiper as SwiperType } from "swiper/types";
import { IoIosCloseCircleOutline } from "react-icons/io";
import { FreeMode, Navigation, Thumbs } from "swiper/modules";
import type { ListingDetailed } from "../../interfaces/listing";

interface BrowseSliderProps {
  setShowSlider: (showSlider: boolean) => void;
  listing: ListingDetailed | null;
  activeIndex: number;
}
const BrowseSlider = ({
  setShowSlider,
  listing,
  activeIndex,
}: BrowseSliderProps) => {
  const [thumbsSwiper, setThumbsSwiper] = useState<SwiperType | null>(null);

  if (!listing || !listing.images || listing.images.length === 0) {
    return (
      <div className="fixed inset-0 bg-[#171717] mb-10 w-full h-full z-[60] flex justify-center items-center">
        <button
          className="text-white text-xl"
          onClick={() => setShowSlider(false)}
        >
          Close
        </button>
        <p className="text-white mt-4">No images available.</p>
      </div>
    );
  }

  const validActiveIndex =
    activeIndex >= 0 && activeIndex < listing.images.length ? activeIndex : 0;

  return (
    <div className="fixed inset-0 bg-[#171717] mb-10 w-full h-full z-[60] max-h-vh grid gap-6 grid-cols-[100%] grid-rows-[100px_calc(-340px_+_100vh)_224px]">
      <div className="h-[100px] text-white w-full flex items-center justify-between px-20">
        <span className="text-4xl">{listing?.address}</span>
        <div
          className="flex items-center space-x-3 cursor-pointer"
          onClick={() => setShowSlider(false)}
        >
          <IoIosCloseCircleOutline className="text-3xl" />
          <span className="text-2xl">Close</span>
        </div>
      </div>

      <div className="relative flex items-center justify-center">
        <Swiper
          navigation={{
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          }}
          initialSlide={validActiveIndex}
          className="pb-8 h-full w-2/3 rounded-2xl"
          onSwiper={(swiperInstance) => setThumbsSwiper(swiperInstance)}
          watchSlidesProgress={true}
          spaceBetween={10}
          loop={true}
          thumbs={thumbsSwiper ? { swiper: thumbsSwiper } : undefined}
          modules={[FreeMode, Navigation, Thumbs]}
        >
          {listing?.images?.map((image, index) => (
            <SwiperSlide key={image} className="rounded-2xl overflow-hidden">
              <img
                src={image}
                // biome-ignore lint/a11y/noRedundantAlt: <explanation>
                alt={`Full Image ${index + 1}`}
                className="w-full h-full object-contain"
              />
            </SwiperSlide>
          ))}
        </Swiper>
        <div className="swiper-button-prev !text-white !left-20" />
        <div className="swiper-button-next !text-white !right-20" />
      </div>
      <div className="h-[224px] px-20">
        <Swiper
          onSwiper={setThumbsSwiper}
          loop={true}
          spaceBetween={20}
          slidesPerView={6}
          freeMode={true}
          watchSlidesProgress={true}
          modules={[FreeMode, Navigation, Thumbs]}
          className="listing-property-slider h-[180px] py-5"
        >
          {listing?.images?.map((image, index) => (
            <SwiperSlide
              key={image}
              className="h-[100px] w-[100px] cursor-pointer rounded-2xl overflow-hidden"
            >
              <img
                src={image}
                alt={`Thumbnail ${index + 1}`}
                className="w-full h-full object-cover"
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export { BrowseSlider };
